import { useState } from "react";
import {
    DELIVERY_CALENDAR_THEME,
    buildDeliveryCalendarDays,
    buildDeliveryOccurrences,
    buildDeliveryWeekDays,
} from "./deliveryCalendar";
import { deliveryCalendarCardStyle } from "./deliveryCalendarStyles";
import { DeliveryCalendarGrid, DeliveryCalendarHeader, DeliveryCalendarNavigation } from "./DeliveryCalendarView";
import { DeliveryPlanningModal } from "./DeliveryPlanningModal";
import { useDeliveryData, useDeliveryDragDrop, useDeliveryForm } from "./useDeliveryPlanning";

export function DeliveryPlanningTab() {
    const { plannings, setPlannings, ehpads, drivers, loading } = useDeliveryData();
    const delivery = useDeliveryForm({ ehpads, setPlannings });
    const drag = useDeliveryDragDrop(setPlannings);
    const [calendarMonth, setCalendarMonth] = useState(() => new Date());
    const [calendarView, setCalendarView] = useState("month");

    const calendarDays = calendarView === "week"
        ? buildDeliveryWeekDays(calendarMonth)
        : buildDeliveryCalendarDays(calendarMonth);
    const planningsByDate = buildDeliveryOccurrences(plannings, calendarDays);
    const visibleDeliveryCount = Object.values(planningsByDate).reduce((total, dayPlannings) => total + dayPlannings.length, 0);

    return (
        <div>
            <div style={deliveryCalendarCardStyle}>
                <DeliveryCalendarHeader
                    loading={loading}
                    visibleDeliveryCount={visibleDeliveryCount}
                    calendarView={calendarView}
                    setCalendarView={setCalendarView}
                    onAdd={() => delivery.openCreateModal()}
                />
                <DeliveryCalendarNavigation calendarMonth={calendarMonth} calendarView={calendarView} setCalendarMonth={setCalendarMonth} />
                {loading ? (
                    <p style={{ color: DELIVERY_CALENDAR_THEME.gray, fontSize: "14px", padding: "0 28px 24px" }}>Chargement...</p>
                ) : (
                    <DeliveryCalendarGrid
                        calendarDays={calendarDays}
                        planningsByDate={planningsByDate}
                        calendarView={calendarView}
                        drag={drag}
                        onAdd={dateKey => delivery.openCreateModal(dateKey)}
                        onEdit={delivery.handleEdit}
                    />
                )}
            </div>

            {delivery.modalOpen && <DeliveryPlanningModal delivery={delivery} ehpads={ehpads} drivers={drivers} loading={loading} />}
        </div>
    );
}
